import { getContentValues } from '@truqc/content-path';
const getFilenameTitle = displayName => {
  if (!displayName || typeof displayName !== 'string') return '';
  const lastDot = displayName.lastIndexOf('.');
  const name = lastDot === -1 ? displayName : displayName.slice(0, lastDot);
  return name.trim();
};
const normalizeForComparison = value => {
  if (value == null || typeof value !== 'string') return '';
  return value.trim().toLowerCase();
};

/**
  * @function evaluate - evaluate docRipperProcessMatchesBehavior
  */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  // hardcoded content path - only one envisioned use, so hardcoding simplifies things
  const rippableDocument = getContentValues('/parsedPDF/*/', content)[0];
  const potentialMatches = await evaluateSource({
    type: 'getCacheValueBehavior',
    name: 'docRipper/potentialMatches'
  });
  const pdfPageArray = await evaluateSource({
    type: 'getCacheValueBehavior',
    name: 'docRipper/parsedPDF'
  });
  if (!rippableDocument) {
    return {
      rippableDocument: undefined,
      pages: [],
      forms: {},
      wholeFileForms: []
    };
  }
  const filenameTitle = getFilenameTitle(rippableDocument.displayName);
  const normalizedFilenameTitle = normalizeForComparison(filenameTitle);
  const pdfPages = {};
  const safePageArray = pdfPageArray !== null && pdfPageArray !== void 0 ? pdfPageArray : [];
  safePageArray.forEach((page, index) => {
    pdfPages[index + 1] = page;
  });
  const formIDs = Object.keys(potentialMatches !== null && potentialMatches !== void 0 ? potentialMatches : {});
  const pageIDs = Object.keys(pdfPages);

  // First pass: filename match → whole-file association (exclude from page-based)
  const wholeFileForms = [];
  const formIDsForPageMatch = [];
  for (let i = 0; i < formIDs.length; i += 1) {
    const formID = formIDs[i];
    const fieldValue = potentialMatches[formID];
    const normalizedField = normalizeForComparison(fieldValue);
    if (normalizedFilenameTitle && normalizedField === normalizedFilenameTitle) {
      wholeFileForms.push(formID);
    } else {
      formIDsForPageMatch.push(formID);
    }
  }

  // Second pass: page-text match (same as before, only for forms not in wholeFileForms)
  const matchingForms = {};
  const matchingPages = {};
  for (let i = 0; i < formIDsForPageMatch.length; i += 1) {
    const formID = formIDsForPageMatch[i];
    // to do - make the matches and values case "insensitive"
    // https://app.clickup.com/t/86du0n3er
    const fieldValue = potentialMatches[formID];
    for (let j = 0; j < pageIDs.length; j += 1) {
      const pageID = pageIDs[j];
      const pageText = pdfPages[pageID];
      // to do - need to switch from doing "includes" to splitting on '\n', '\r', ' '
      // https://app.clickup.com/t/86du0n3er
      if (pageText.includes(fieldValue)) {
        matchingPages[pageID] = true;
        if (matchingForms[formID] === undefined) {
          matchingForms[formID] = {};
        }
        matchingForms[formID][pageID] = true;
      }
    }
  }
  const pages = Object.keys(matchingPages);
  const forms = {};
  Object.keys(matchingForms).forEach(formID => {
    forms[formID] = Object.keys(matchingForms[formID]);
  });
  const result = {
    rippableDocument,
    pages,
    forms,
    wholeFileForms
  };
  return result;
};
export default {
  evaluate
};